class ProfileDataStorage {
    LOCALSTORAGE_PREFIX = "profile.data";
    localstorage = process.env.PROFILE_DATA_TARGET === "localstorage";
    avalanche = process.env.PROFILE_DATA_TARGET === "avalanche";
    avalancheProvider;
    walletProvider;
    constructor(avalancheProvider, walletProvider) {
        this.avalancheProvider = avalancheProvider;
        this.walletProvider = walletProvider;
    }
    async get() {
        if (this.avalanche) {
            return this.avalancheProvider.get();
        }
        else if (this.localstorage) {
            return localStorage.getItem(this.LOCALSTORAGE_PREFIX) ?? undefined;
        }
        return undefined;
    }
    async getDataForAddress(key) {
        if (this.avalanche) {
            return this.avalancheProvider.getDataForAddress(key);
        }
        else if (this.localstorage) {
            return localStorage.getItem(this.LOCALSTORAGE_PREFIX) ?? undefined;
        }
        return undefined;
    }
    async set(toStore) {
        if (this.avalanche) {
            this.avalancheProvider.set(toStore);
        }
        else if (this.localstorage) {
            localStorage.setItem(this.LOCALSTORAGE_PREFIX, toStore);
        }
    }
    async setDataForAddress(key, toStore) {
        if (this.avalanche) {
            this.avalancheProvider.setDataForAddress(key, toStore);
        }
        else if (this.localstorage) {
            localStorage.setItem(this.LOCALSTORAGE_PREFIX, key);
        }
    }
    async hasData() {
        if (this.avalanche) {
            return this.avalancheProvider.hasData();
        }
        else if (this.localstorage) {
            return localStorage.getItem(this.LOCALSTORAGE_PREFIX) !== null;
        }
        return false;
    }
    async hasDataForAddress(key) {
        if (this.avalanche) {
            return this.avalancheProvider?.hasDataForAddress(key);
        }
        else if (this.localstorage) {
            return localStorage.getItem(this.LOCALSTORAGE_PREFIX) !== null;
        }
        return false;
    }
    async delete() {
        if (this.avalanche) {
            this.avalancheProvider.set("");
        }
        else if (this.localstorage) {
            localStorage.removeItem(this.LOCALSTORAGE_PREFIX);
        }
    }
    async deleteForAddress(key) {
        if (this.avalanche) {
            this.avalancheProvider.setDataForAddress(key, "");
        }
        else if (this.localstorage) {
            localStorage.removeItem(this.LOCALSTORAGE_PREFIX);
        }
    }
}
export default ProfileDataStorage;
